
import {defineComponent, ref} from "vue";
import authStore from "@/store/auth";

export default defineComponent({
  name: 'AccountSettingsPage',
  components: {},
  setup() {
    const {
      authState,
      initConfirmEmail,
      gRecaptchaKey
    } = authStore

    const initConfirmEmailMessageSent = ref(false)

    return {
      authState,
      initConfirmEmail,
      gRecaptchaKey,
      captchaToken: "",
      initConfirmEmailMessageSent
    }
  },
  methods: {
    async handleInitConfirmEmail() {
      await grecaptcha.ready(async () => {
        this.captchaToken = await grecaptcha.execute(this.gRecaptchaKey, {
          action: "login",
        });

        await this.initConfirmEmail(this.captchaToken, () => {
          this.initConfirmEmailMessageSent = true
        });
      });
    },
  }
})
